import style from './style.css.scss'

export function scrollToElement({ elemClass, addViewPort = false }) {
  let element = document.getElementsByClassName(elemClass)[0]
  const deviceHeight = window.__deviceHeight__ || window.innerHeight
  const headerHeight = parseInt(style.headerHeight)
  const scrollY = element.offsetTop - headerHeight + (addViewPort ? deviceHeight : 0)

  window.scrollTo(0, scrollY)
  window.dispatchEvent(
    new CustomEvent("scrollToElement", {
      detail: {
        x: 0,
        y: scrollY + headerHeight // in embedded board the header is not sticky and shouldn't be deducted
      }
    })
  )
}
